/**
 * Pagination utility functions
 * Shared calculations to avoid duplication between hook and component
 */

export const calculateTotalPages = (totalItems: number, rowsPerPage: number): number => {
	return Math.ceil(totalItems / rowsPerPage);
};

export const calculateStartIndex = (
	currentPage: number,
	rowsPerPage: number,
	totalItems: number
): number => {
	if (totalItems === 0) {
		return 0;
	}
	return (currentPage - 1) * rowsPerPage + 1;
};

export const calculateEndIndex = (
	currentPage: number,
	rowsPerPage: number,
	totalItems: number
): number => {
	return Math.min(currentPage * rowsPerPage, totalItems);
};

export const isPageValid = (page: number, totalPages: number): boolean => {
	return page >= 1 && page <= totalPages;
};

export interface PaginationValues {
	endIndex: number;
	hasNextPage: boolean;
	hasPrevPage: boolean;
	startIndex: number;
	totalPages: number;
}

export const calculatePaginationValues = (
	currentPage: number,
	rowsPerPage: number,
	totalItems: number
): PaginationValues => {
	const totalPages = calculateTotalPages(totalItems, rowsPerPage);
	const startIndex = calculateStartIndex(currentPage, rowsPerPage, totalItems);
	const endIndex = calculateEndIndex(currentPage, rowsPerPage, totalItems);
	const hasNextPage = currentPage < totalPages;
	const hasPrevPage = currentPage > 1;

	return {
		totalPages,
		startIndex,
		endIndex,
		hasNextPage,
		hasPrevPage,
	};
};
